import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PaypalButtonComponent, PaypalAgreementRedirectComponent, StripePaymentComponent } from './components';
import { MutualModule } from '@shared/mutual/mutual.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';

@NgModule({
  declarations: [PaypalButtonComponent, PaypalAgreementRedirectComponent, StripePaymentComponent],
  imports: [CommonModule, TranslateModule, MutualModule, PipesSharedModule],
  exports: [PaypalButtonComponent, PaypalAgreementRedirectComponent, StripePaymentComponent],
})
export class PaymentButtonExternalModule {}
